import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { apm } from "./Apm";
import { _TEST1234 } from "./ApiConfig";
import { SensitiveDataSanitizer } from "../security/SensitiveDataSanitizer";

const ApmConfig = () => {
    const { pathname } = useLocation();
    const [searchParams] = useSearchParams();
    const menuId = searchParams.get("menuId");

    const getCustomContext = () => {
        const customContext = {
            signed: false,
            user: null as string | null,
            system: _TEST1234.SYSTEM,
            systemGroup: _TEST1234.SYSTEM_GROUP_ORI,
        };

        const userInfo = sessionStorage.getItem("user-info");

        if (!userInfo) {
            return SensitiveDataSanitizer.sanitize(customContext);
        }

        try {
            const parsedUserInfo = JSON.parse(userInfo);

            customContext.signed = true;
            customContext.user = parsedUserInfo?.usrId ?? null;
        } catch {
            customContext.signed = false;
            customContext.user = null;
        }

        return SensitiveDataSanitizer.sanitize(customContext);
    };

    const getRoutePath = (
        pathname: string,
        menuId: string | null,
    ): string => {
        return menuId ? `${pathname}?menuId=${menuId}` : pathname;
    };

    useEffect(() => {
        if (!apm) {
            return;
        }

        const customContext = getCustomContext();
        const routePath = getRoutePath(pathname, menuId);

        apm.setCustomContext?.(customContext);

        const transaction = apm.startTransaction?.(
            routePath,
            "route-change",
            {
                managed: true,
            },
        );

        const blocker = transaction?.startSpan?.(
            "route-change-blocker",
            "app",
            {
                blocking: true,
            },
        );

        return () => {
            blocker?.end?.();
            transaction?.end?.();
        };
    }, [pathname, menuId]);

    return null;
};

export default ApmConfig;